import { apiService } from '@/api/apiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export const setEmailConfirmationApi = async (
  userId: string,
  token: string
): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = `/users/${userId}/email-confirmation/${token}/`;

  return apiService.PATCH(uri, {});
};
